import { useEffect } from 'react';
import { hasStoredAnalyticsConsent, isEuropeVisitor } from '@/lib/europeVisitor';
import { sendPageView } from '@/lib/gaPageView';

/**
 * Europe only: load gtag after analytics consent. index.html skips the
 * first-party loader for those visitors until this runs. Non-Europe still
 * loads from index.html. Does not set transport_url.
 */
const ConsentScriptsGate = () => {
  useEffect(() => {
    const maybeLoad = () => {
      if (!isEuropeVisitor()) return;
      if (!hasStoredAnalyticsConsent()) return;
      const already =
        !!window.__c2Ga4Loading ||
        !!window.__c2Ga4Loaded ||
        !!window.__ga4FellBack;
      window.__c2LoadGa4?.();
      if (!already) {
        window.setTimeout(() => sendPageView(), 0);
      }
    };

    maybeLoad();
    window.addEventListener('consentUpdated', maybeLoad);
    return () => window.removeEventListener('consentUpdated', maybeLoad);
  }, []);

  return null;
};

export default ConsentScriptsGate;
